import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// Convert an image URL to a base64 data URL via the backend proxy endpoint.
// Returns "" on any failure so callers can treat it as "no image".
export const urlToBase64 = async (url) => {
  if (!url) return "";
  try {
    // Use proxy endpoint
    const response = await axios.get(
      `${API_URL}/api/proxy-image?url=${encodeURIComponent(url)}`,
      { responseType: "blob" }
    );

    const blob = response.data;
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => resolve(reader.result);
    });
  } catch (error) {
    console.error("Error converting image to base64:", error);
    return "";
  }
};

export default urlToBase64;
